import * as React from 'react';
import { ICenterBase } from '@nkr/models/index';
import { Button, Col, ControlLabel, FormControl, FormGroup, Row, Well } from 'react-bootstrap';

interface IProps {
    centerId: number,
    firstName: string,
    lastName: string,
    isAdmin: boolean,
    centerList: ICenterBase[],
    onChange: (center: number, firstName: string, lastName: string) => void,
    onSearch: () => void,
    onReset: () => void,
    onAdd: () => void
}

const Search = (props: IProps) => {
    const handleTextChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        let { firstName, lastName } = props;

        if (e.currentTarget.name == 'firstName') {
            firstName = e.currentTarget.value;
        }

        if (e.currentTarget.name == 'lastName') {
            lastName = e.currentTarget.value;
        }

        props.onChange(props.centerId, firstName, lastName);
    };

    return (
        <Well bsSize='sm'>
            <Row>
                {props.isAdmin && (
                    <Col xs={12} sm={6} lg={2}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <ControlLabel>Center</ControlLabel>
                            <FormControl
                                componentClass='select'
                                value={props.centerId}
                            // onChange={handleCenterChange}
                            >
                                <option value={0}>- ALL -</option>
                                {props.centerList.map((item, index) =>
                                    <option key={'ctr-' + index} value={item.id}>{item.alias}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>
                )}

                <Col xs={12} sm={6} lg={2}>
                    <FormGroup style={{ marginBottom: 0 }}>
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                            name='firstName'
                            value={props.firstName}
                            onChange={handleTextChange}
                        />
                    </FormGroup>
                </Col>

                <Col xs={12} sm={6} lg={2}>
                    <FormGroup style={{ marginBottom: 0 }}>
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                            name='lastName'
                            value={props.lastName}
                            onChange={handleTextChange}
                        />
                    </FormGroup>
                </Col>

                <Col xs={12} lg={2} style={{ paddingTop: 25 }}>
                    <Button block bsStyle='primary' style={{ marginRight: 5 }} onClick={props.onSearch}>Search</Button>
                </Col>
                <Col xs={12} lg={2} style={{ paddingTop: 25 }}>
                    <Button block onClick={props.onReset}>Reset Filters</Button>
                </Col>

                {props.isAdmin == false && (
                    <Col xs={12} lg={2} style={{ paddingTop: 25 }}>
                        <Button block bsStyle='success' onClick={props.onAdd}>Add Donor</Button>
                    </Col>
                )}
            </Row>
        </Well >
    )
}

export default Search;